import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=acb0652e&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=acb0652e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acb0652e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('acb0652e')) {
      api.createRecord('acb0652e', component.options)
    } else {
      api.reload('acb0652e', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=acb0652e&scoped=true&", function () {
      api.rerender('acb0652e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2g405pW6P39kO/JS/comp/GuestBox.vue"
export default component.exports